var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vuse-content-wrapper"},[_c('vuse-section-definition',{attrs:{"title":_vm.page,"icon":"dashboard"}}),_c('v-container',{attrs:{"fluid":""}},[_c('h1',[_vm._v("Hi "+_vm._s(_vm.userName))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }